class Confetti {
  static count = 200;
  static defaults = {
    origin: { y: 0.7 }
  };

  static fire(particleRatio, opts) {
    confetti({
      ...Confetti.defaults,
      ...opts,
      particleCount: Math.floor(Confetti.count * particleRatio)
    });
  }

  static run() {
    Confetti.fire(0.25, { spread: 26, startVelocity: 55, });
    Confetti.fire(0.2, { spread: 60, });
    Confetti.fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 });
    Confetti.fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
    Confetti.fire(0.1, { spread: 120, startVelocity: 45, });
  }

  static getRandomColor() {
    const colors = ['#ff6347', '#ffa500', '#32cd32', '#1e90ff', '#ff69b4'];
    return colors[Math.floor(Math.random() * colors.length)];
  }
}

document.addEventListener("turbo:render", function(c, n) {
  const run_confetti = document.querySelector("[confetti='true']")
  if (run_confetti) {
    Confetti.run()
  }
});
